import type { CSSProperties, PropsWithChildren } from 'react';

import { MagnifyingGlass } from '@phosphor-icons/react';

import { cn } from '@/utils/cn';

import { RSS_FEED_SEARCH_DEFAULTS } from './constants';
import * as styles from './RSSFeedSearch.css';
import type { RSSFeedSearchElementProps } from './RSSFeedSearch.types';

const ALIGNMENT = {
  center: 'justify-center',
  left: 'justify-start',
  right: 'justify-end',
};

export const RSSFeedSearchElement = (
  props: PropsWithChildren<
    RSSFeedSearchElementProps & {
      onClick?: () => void;
    }
  >,
) => {
  const { element, attributes, children, className, onClick } = props;

  const {
    alignment = RSS_FEED_SEARCH_DEFAULTS.alignment,
    maxWidth = RSS_FEED_SEARCH_DEFAULTS.maxWidth,
    maxHeight = RSS_FEED_SEARCH_DEFAULTS.maxHeight,
    marginBottom = RSS_FEED_SEARCH_DEFAULTS.marginBottom,
    borderWidth = RSS_FEED_SEARCH_DEFAULTS.borderWidth,
    borderColor = RSS_FEED_SEARCH_DEFAULTS.borderColor,
    borderStyle = RSS_FEED_SEARCH_DEFAULTS.borderStyle,
    borderRadius = RSS_FEED_SEARCH_DEFAULTS.borderRadius,
    backgroundColor = RSS_FEED_SEARCH_DEFAULTS.backgroundColor,
    placeholderColor = RSS_FEED_SEARCH_DEFAULTS.placeholderColor,
    iconFill = RSS_FEED_SEARCH_DEFAULTS.iconFill,
    placeholder = RSS_FEED_SEARCH_DEFAULTS.placeholder,
  } = element.attrs;

  return (
    <div
      className={cn('relative flex flex-col w-full', className)}
      style={
        {
          '--input-background-color': backgroundColor,
          '--input-placeholder-color': placeholderColor,
          '--input-border-radius': borderRadius,
          '--input-border-width': borderWidth,
          '--input-border-color': borderColor,
          '--input-border-style': borderStyle,
          '--input-icon-fill': iconFill,
          '--input-max-width': maxWidth,
          '--input-max-height': maxHeight,
          '--input-margin-bottom': marginBottom,
        } as CSSProperties
      }
      {...attributes}
    >
      <div className={cn('flex items-center w-full', ALIGNMENT[alignment])}>
        <button
          type="button"
          onClick={onClick}
          className={cn('relative flex items-center w-full cursor-pointer', styles.searchInputContainer)}
        >
          <MagnifyingGlass className={cn('absolute left-3 h-4 w-4', styles.searchInputIconFill)} />
          <div
            className={cn('w-full border p-4 pl-9 text-left', styles.searchTriggerStyle)}
            style={{
              borderRadius,
              borderWidth,
              borderColor,
              borderStyle,
            }}
          >
            <span style={{ color: placeholderColor }}>{placeholder}</span>
          </div>
        </button>
      </div>
      {children}
    </div>
  );
};
